import React from "react";
import { connect } from "react-redux";

import Modal from "reboron/DropModal";

import { fetchP24Transaction } from "../../../actions/p24TransactionActions";

import { PageHeader } from "../../../components/PageHeader";

import P24TransactionForm from "../../../components/p24/P24TransactionForm";


// Individual styles for the modal, modal content, and backdrop
const modalStyle = {
    //transform: 'rotate(45deg) translateX(-50%)',
    //width: '80%'
    width: '800px'
};

const backdropStyle = {
    // backgroundColor: 'red',
};

const contentStyle = {
    // backgroundColor: 'blue',
    height: '100%',
};


/**
 * Widok pojedyńczej transakcji P24
 */
class P24Transaction extends React.Component {

    componentDidMount() {

        //ladowanie danych do tabeli
        this.props.fetchP24Transaction(this.props.match.params.id);
    }


    /**
    * Pokazuje modal
    */
    showModal() {
        this.refs.modal.show();
    }

    /**
     * Chowa modal
     */
    hideModal = () => {
        this.refs.modal.hide();
    };

    addButton() {
        return <button
            className="w3-btn w3-theme-dark"
            onClick={() => this.showModal()}
        >
            {this.props.formatMessage("app.p24TransactionPage.addTransaction")}
        </button>
    }

    onCreateAction = (transaction) => {
        this.props.createTransaction(transaction);
        this.hideModal();
    }

    render() {

        return (
            <div>
                <PageHeader text="app.p24TransactionPage.title" />

                {this.props.p24Transaction && this.props.p24Transaction.id}

                <Modal ref={"modal"} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle}>
                    <P24TransactionForm title='Nowa transakcja' onCancel={this.hideModal} onSubmit={this.onCreateAction} />
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    p24Transaction: state.p24TransactionReducer.p24Transaction,
    authenticatedUser: state.authReducer.authenticatedUser
});


const mapDispatchToProps = ({
    fetchP24Transaction: fetchP24Transaction
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(P24Transaction);